enum ScrollProgressEnum {
  Start = 'Start',
  Middle = 'Middle',
  End = 'End',
}

export default ScrollProgressEnum;
